export const ErrorsEnum = {
  // SUBSCRIBER ISSUES
  SUBSCRIBER_IS_NOT_ABROAD: 'SUBSCRIBER_IS_NOT_ABROAD',
  NO_CELLULAR_SUBSCRIBER: 'NO_CELLULAR_SUBSCRIBER',
  BUSINESS_SUBSCRIBER: 'BUSINESS_SUBSCRIBER',
  KOSHER_SUBSCRIBER: 'KOSHER_SUBSCRIBER',
  DATA_ONLY: 'DATA_ONLY',
  DEFENSE_POLICY_BLOCKED: 'DEFENSE_POLICY_BLOCKED',

  // ROAMING ISSUES
  ROAMING_BLOCKED: 'ROAMING_BLOCKED',
  AMDOCS_ROAMING_BLOCKED: 'AMDOCS_ROAMING_BLOCKED',
  AMDOCS_ROAMING_BLOCKED_CALLS: 'AMDOCS_ROAMING_BLOCKED_CALLS',
  EGYPT_AND_JORDAN_BLOCKED__CALL_SERVICE: 'EGYPT_AND_JORDAN_BLOCKED__CALL_SERVICE',
  EGYPT_AND_JORDAN_BLOCKED__BUY_PACKAGE: 'EGYPT_AND_JORDAN_BLOCKED__BUY_PACKAGE',

  // SERVICE ISSUES
  NO_SERVICE: 'NO_SERVICE',
  CELLULAR_DATA_OFF: 'CELLULAR_DATA_OFF',
  NO_DATA_AND_ROAMING: 'NO_DATA_AND_ROAMING',
  CALL_FORWARDING_PREVENTS_RECEIVING_CALLS: 'CALL_FORWARDING_PREVENTS_RECEIVING_CALLS',
  CANT_FIND_ISSUE_WITH_LINE_SETTINGS: 'CANT_FIND_ISSUE_WITH_PHONE_LINE_SETTINGS',

  // PACKAGE ISSUES
  NO_ABROAD_PACKAGE: 'NO_ABROAD_PACKAGE',
  NO_CELLULAR_PACKAGE: 'NO_CELLULAR_PACKAGE',
  EXPIRED_PACKAGE: 'EXPIRED_PACKAGE',
  INCOMPATIBLE_PACKAGE: 'INCOMPATIBLE_PACKAGE',
  ABROAD_PACKAGE_WITHOUT_CALLS: 'ABROAD_PACKAGE_WITHOUT_CALLS',
  ABROAD_PACKAGE_DOES_NOT_FIT_TO_DESTINATION: 'ABROAD_PACKAGE_DOES_NOT_FIT_TO_DESTINATION',

  // FINANCIAL ISSUES
  FINANCIAL_DEBT_ERROR: 'FINANCIAL_DEBT_ERROR',
  FINANCIAL_PAYMENT_UPDATE_ERROR: 'FINANCIAL_PAYMENT_UPDATE_ERROR',
  FINANCIAL_PAYMENT_METHOD_UPDATE_ERROR: 'FINANCIAL_PAYMENT_METHOD_UPDATE_ERROR',

  // SUSPENDED SUBSCRIBER ISSUES
  SUSPENDED_SUBSCRIBER_LOST_OR_STOLEN: 'SUSPENDED_SUBSCRIBER_LOST_OR_STOLEN',
  SUSPENDED_SUBSCRIBER: 'SUSPENDED_SUBSCRIBER',

  // REPRESENTATIVE ISSUES
  CONTINUE_TO_REPRESENTATIVE: 'CONTINUE_TO_REPRESENTATIVE',
  UNRESOLVED_ISSUE: 'UNRESOLVED_ISSUE',
  CANT_RESOLVE_ISSUE: 'CAN_NOT_RESOLVE_ISSUE',
  UPDATE_FAILED: 'UPDATE_FAILED',
  // GENERAL ERRORS
  GENERAL_ERROR: 'GENERAL_ERROR',

  // CALLBACK ISSUES
  CALLBACK_ALREADY_SCHEDULED: 'CALLBACK_ALREADY_SCHEDULED',
};
